
import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";

@Component
export default class FileDrop extends Vue {
  @Prop({ default: 75 }) iconSize!: number;

  @Prop({ default: 125 }) dropzoneHeight!: number;

  @Prop({
    default: "Drag'n drop, einfach deine Datei(en) in dieser Fläche ziehen!",
  })
  title!: string;

  // internal properties
  formUpload = false;
  dragover = false;
  isSelecting = false;

  mounted(): void {
    // to register listeners, we have to know the
    // html elements
    const dropzone = this.$el;
    const fileupload = this.$el.firstElementChild as HTMLElement;

    // register listeners on your dropzone / v-sheet
    if (dropzone) {
      // register all drag & drop event listeners
      dropzone.addEventListener("dragenter", (e) => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("dragleave", (e) => {
        e.preventDefault();
        this.dragover = false;
      });
      dropzone.addEventListener("dragover", (e) => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("drop", (e) => {
        e.preventDefault();
        const dragevent = e as DragEvent;
        if (dragevent.dataTransfer) {
          this.filesSelected(dragevent.dataTransfer.files);
        }
      });
      dropzone.addEventListener("click", (e) => {
        (this.$refs.upload as HTMLElement).click();
      });

      dropzone.addEventListener("keypress", (e) => {
        e.preventDefault();
        const keyEvent = e as KeyboardEvent;
        if (keyEvent.key === "Enter") {
          if (fileupload) fileupload.click();
        }
      });

      // register listeners on the file input
      if (fileupload) {
        fileupload.addEventListener("change", (e) => {
          const target = e.target as HTMLInputElement;
          if (target.files) {
            this.filesSelected(target.files);
          }
        });
      }
    }
  }

  /**
   * upload event...
   */
  @Emit()
  filesSelected(fileList: FileList): void {
    this.dragover = false;
  }
}
